import(/* webpackMode: "eager" */ "/codebuild/output/src2425249190/src/apps/wrap.gifts/node_modules/next/dist/client/link.js");
